import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { verifyEmail } from '../../services/authService';
import useAuth from '../../hooks/useAuth';
import { MdCheckCircle, MdError } from 'react-icons/md';
import BrandLogo from '../../components/common/BrandLogo';
import { ROLE_DASHBOARDS } from '../../utils/constants';

function VerifyEmail() {
  const { token }   = useParams();
  const { login }   = useAuth();
  const navigate    = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail(token)
      .then(({ data }) => {
        if (data.autoLogin) {
          login(data.user, data.token);
          setTimeout(() => navigate(ROLE_DASHBOARDS[data.user.role] || '/login', { replace: true }), 1500);
        }
        setStatus('success');
        setMessage(data.message || 'Email verified!');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed. The link may have expired.');
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#141312] flex flex-col items-center justify-center px-4">
      <div className="flex items-center gap-2 mb-8">
        <BrandLogo size={28} />
        <span className="font-bold text-[#ede8e0] text-xl">TrainAxis</span>
      </div>

      <div className="bg-[#1e1d1b] rounded-2xl border border-[rgba(237,232,224,0.08)] shadow-2xl p-8 max-w-sm w-full text-center">
        {status === 'loading' && (
          <>
            <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-[#8a847c] text-sm">Verifying your email…</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MdCheckCircle className="text-green-500 text-4xl" />
            </div>
            <h2 className="text-[#ede8e0] font-bold text-xl mb-2">Email Verified!</h2>
            <p className="text-[#8a847c] text-sm mb-6">{message}</p>
            <Link to="/login"><button className="w-full bg-primary text-white hover:bg-primary-dark py-3 rounded-full font-medium">Continue to Login</button></Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MdError className="text-red-500 text-4xl" />
            </div>
            <h2 className="text-[#ede8e0] font-bold text-xl mb-2">Verification Failed</h2>
            <p className="text-[#8a847c] text-sm mb-6">{message}</p>
            <Link to="/login"><button className="w-full bg-primary text-white hover:bg-primary-dark py-3 rounded-full font-medium">Back to Login</button></Link>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
